import type Phaser from "phaser";

import type { TailClipRuntimeSnapshot } from "../application/tail-clip-runtime";
import { gameplayConfig } from "../config/gameplay-config";
import type { MotionProfile } from "../config/motion-config";
import type { Vector2 } from "../simulation/player-movement";

export class TailClipRenderer {
  public constructor(
    private readonly graphics: Phaser.GameObjects.Graphics,
    private readonly levelDownText: Phaser.GameObjects.Text,
  ) {}

  public destroy(): void {
    this.graphics.destroy();
    this.levelDownText.destroy();
  }

  public render(
    snapshot: TailClipRuntimeSnapshot,
    simulationTimeMs: number,
    motionProfile: MotionProfile,
    playerPosition: Vector2 | null,
  ): void {
    this.graphics.clear();
    const clip = snapshot.lastClip;
    if (clip === null) {
      this.levelDownText.setVisible(false);
      return;
    }
    const age = simulationTimeMs - clip.occurredAtMs;
    const duration =
      motionProfile.particleOpacity === 0
        ? Math.min(240, gameplayConfig.tailClipping.feedbackDurationMs)
        : gameplayConfig.tailClipping.feedbackDurationMs;
    if (age < 0 || age >= duration) {
      this.levelDownText.setVisible(false);
      return;
    }
    const progress = age / duration;
    const alpha = motionProfile.particleOpacity === 0 ? 0.95 : 1 - progress;
    const radius =
      motionProfile.particleOpacity === 0 ? 14 : 10 + progress * 22;
    this.graphics.lineStyle(5, 0xffe066, alpha);
    for (const position of clip.positions) {
      this.graphics.strokeCircle(position.x, position.y, radius);
    }
    const cue = clip.victimDefeated
      ? null
      : clip.attackerId === "player"
        ? `+${String(clip.growthTransferred)}`
        : clip.victimId === "player"
          ? "Level down!"
          : null;
    if (cue === null || playerPosition === null) {
      this.levelDownText.setVisible(false);
      return;
    }
    this.levelDownText
      .setPosition(playerPosition.x, playerPosition.y - 28)
      .setText(cue)
      .setAlpha(alpha)
      .setVisible(true);
  }
}
